"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_router_dom_1 = require("react-router-dom");
var reactstrap_1 = require("reactstrap");
var ClassNameExtendableHoC_1 = __importDefault(require("components/Generic/ClassNameExtendableHoC"));
var LoadingSingleInline_1 = __importDefault(require("components/LoadingSpinner/LoadingSingleInline"));
var ButtonType = function (_a) {
    var to = _a.to, href = _a.href, _b = _a.color, color = _b === void 0 ? '' : _b, _c = _a.outline, outline = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? '' : _d, isSending = _a.isSending, children = _a.children, props = __rest(_a, ["to", "href", "color", "outline", "size", "isSending", "children"]);
    var childrenWithLoader = !isSending ? children : (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [children, (0, jsx_runtime_1.jsx)(LoadingSingleInline_1.default, { className: "color-white" })] });
    if (props.disabled || isSending || (!to && !href)) {
        return ((0, jsx_runtime_1.jsx)(reactstrap_1.Button, __assign({ color: color, outline: !!outline, size: size }, props, { disabled: isSending || props.disabled }, { children: childrenWithLoader })));
    }
    var linkClasses = (0, classnames_1.default)('btn', "btn-".concat(outline && 'outline-').concat(color), size && "btn-".concat(size));
    if (to) {
        var LinkButton = (0, ClassNameExtendableHoC_1.default)(react_router_dom_1.Link, linkClasses);
        return (0, jsx_runtime_1.jsx)(LinkButton, __assign({ to: to }, props, { children: childrenWithLoader }));
    }
    if (href) {
        var ExtLinkButton = (0, ClassNameExtendableHoC_1.default)('a', linkClasses);
        return href && (0, jsx_runtime_1.jsx)(ExtLinkButton, __assign({ href: href }, props, { children: childrenWithLoader }));
    }
    return null;
};
var ButtonBase = (0, ClassNameExtendableHoC_1.default)(ButtonType, 'ds-button', function (_a) {
    var noMargin = _a.noMargin, actionDone = _a.actionDone, showDisabled = _a.showDisabled, invertUnderline = _a.invertUnderline, anchorTextStyle = _a.anchorTextStyle, multiLine = _a.multiLine, linkStyle = _a.linkStyle, isSending = _a.isSending, inlineText = _a.inlineText, isFlexButton = _a.isFlexButton, noPadX = _a.noPadX, alignVer = _a.alignVer, fontWeightMed = _a.fontWeightMed, isBlack = _a.isBlack, isGreen = _a.isGreen, isHybrid = _a.isHybrid, isPink = _a.isPink;
    return [
        linkStyle,
        {
            'no-margin': noMargin,
            'is-sending': isSending,
            'action-done': actionDone,
            'show-disabled': showDisabled,
            'invert-underline': invertUnderline,
            'ds-anchor-link': anchorTextStyle,
            'ds-button-flex': isFlexButton,
            'flex-column center-content-x-y': multiLine,
            'ds-inline-text': inlineText,
            'px-0': noPadX,
            'align-ver': alignVer,
            'font-w-med': fontWeightMed,
            'btn-black': isBlack,
            'btn-green': isGreen,
            'btn-hybrid': isHybrid,
            pink: isPink,
        },
    ];
}, ['noMargin', 'actionDone', 'linkStyle', 'showDisabled', 'invertUnderline', 'alignVer', 'fontWeightMed', 'noPadX',
    'isBlack', 'isGreen', 'isHybrid']);
exports.default = ButtonBase;
